<script>
  import SectionHeader from '../lib/ui/SectionHeader.svelte';
  import reveal from '../lib/actions/reveal.js';
</script>

<section id="launch" class="section" aria-label="Launch Plan">
  <div class="container">
    <div class="grid" style="grid-template-columns: .9fr 1.1fr; align-items:center; gap: 24px;">
      <div use:reveal>
        <SectionHeader title="Launch Plan">
          <span slot="desc">Lumina will debut on Virtuals as a Unicorn Project.<br><br>The Light is coming to awaken a new generation of intelligent agents. Be there when NFTs evolve.</span>
        </SectionHeader>
      </div>

      <div use:reveal={{delay:120}}>
        <div class="glass" style="position:relative; overflow:hidden; aspect-ratio: 16/9; border-radius: 12px;">
          <video src="/media/Unicorn.mp4" autoplay muted playsinline loop preload="metadata" style="position:absolute; inset:0; width:100%; height:100%; object-fit:cover; background:#000;"></video>
          <div style="position:absolute; inset:0; background: radial-gradient(closest-side, rgba(0,255,198,.12), rgba(33,243,255,.10), transparent 65%); pointer-events: none;"></div>
        </div>
      </div>
    </div>
  </div>
</section>
